module.exports = __webpack_public_path__ + "static/logo-0dbd45e4e4bd2da0df6cc0d65783ac88.svg";